import { RANK_STYLE, rankName, rankOf } from './achievements';
import { useT } from '../../i18n';

/** The runner's rank tier as a small chip, e.g. "🥈 Silver". */
export function RankChip({ level, className = '' }: { level: number; className?: string }) {
  useT(); // re-render on language change
  const rank = rankOf(level);
  const s = RANK_STYLE[rank];
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-bold ${className}`}
      style={{ background: s.bg, color: s.fg }}
      data-testid="rank-chip"
      data-rank={rank}
    >
      <span aria-hidden="true">{s.icon}</span>
      {rankName(rank)}
    </span>
  );
}
